import { apiRequest } from "./Api";

export const createEmployee = (data: any) =>
  apiRequest<FormData, any>("POST", "employee/store", data);

export const getSelfProfile = (id?: string) =>
  apiRequest<any, any>("GET", `hr/user-information?id=${id}`);

export const getEmploye = (params?: any) =>
  apiRequest<any, any>("GET", "hr/users", null, undefined, params);

export const updateEmployee = (data: any) => {
  return apiRequest<FormData, any>("POST", `hr/update-user-information`, data, {
    "content-type": "multipart/form-data",
  });
};

export const showEmployeSelfDocument = (data?: any, link?: string) =>
  apiRequest<any, any>("GET", `hr/show-user-document/${link}`, data);

export const showEmployeDocument = (link?: string) =>
  apiRequest<any, any>("GET", `hr/show-user-document/${link}`);

export const getRolesOfCompany = (data?: any) =>
  apiRequest<any, any>("GET", `roles-of-company`, null, undefined, data);

export const endContract = (data: any) => {
  return apiRequest<FormData, any>("POST", `hr/end-contract`, data, {
    "content-type": "multipart/form-data",
  });
};

export const getRolePermissions = (data?: any) =>
  apiRequest<any, any>("GET", `hr/roles/role-permission`, null, undefined, data);

export const editRolePermissions = (data: any) =>
  apiRequest<FormData, any>("POST", "hr/roles/edit-role-permission", data);

export const createRole = (data: any) =>
  apiRequest<FormData, any>("POST", "hr/roles/store", data);

export const getStatisticCardsData = () =>
  apiRequest<any, any>('GET', 'hr/statistic/info-card', null, undefined, undefined)

export const getSalaryGoals = (params?: any) =>
  apiRequest<any, any>('GET', 'hr/salary/goals', null, undefined, params)

export const getSalaryBonuses = (params?: any) =>
  apiRequest<any, any>('GET', 'hr/salary/bonuse', null, undefined, params)

export const getSalary = (params?: any) =>
  apiRequest<any, any>('GET', 'hr/salary', null, undefined, params)

export const getCommission = (params?: any) =>
  apiRequest<any, any>('GET', 'hr/salary/commission', null, undefined, params)

export const getSalaryPaperHistory = (id?: string) =>
  apiRequest<any, any>("GET", `hr/salary/paper-history?id=${id}`);

export const toggleEmployeeStatus = (data: any) =>
  apiRequest<any, any>("POST", "hr/activ-deactiv-user", data);

export const createLeaveRequest = (data: any) => {
  return apiRequest<FormData, any>("POST", `hr/absence/store`, data, {
    "content-type": "multipart/form-data",
  });
};

export const getLeaveRequests = (params?: any) =>
  apiRequest<any, any>('GET', 'hr/absence', null, undefined, params)

export const createOrderRequest = (data: any) =>
  apiRequest<any, any>("POST", "hr/orders/store", data);

export const getOrderRequests = (params?: any) =>
  apiRequest<any, any>('GET', 'hr/orders', null, undefined, params)

export const getPendingAbsences = (params?: any) =>
  apiRequest<any, any>('GET', 'hr/absence/all', null, undefined, params)

export const giveAbsenceFeedback = (data: any) =>
  apiRequest<any, any>("POST", "hr/absence/feedback", data);

export const getPendingOrders = (params?: any) =>
  apiRequest<any, any>('GET', 'hr/orders/all', null, undefined, params)

export const giveOrderFeedback = (data: any) =>
  apiRequest<any, any>("POST", "hr/orders/feedback", data);